import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Box, Button, Checkbox, FormControlLabel, Grid, MenuItem, TextField, } from "@mui/material";
import axios from 'axios';
import { useEffect, useState, } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from '../../constants/apiConstants';
import { useMessage } from '../../context/message-context';
import apiRequest from '../../functions/api';
import { pad } from "../../functions/default";
import { DateTextField, FullPageSpinner } from '../lib';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import Layout from "../shared/components/LayoutComponent";
import Page from "../shared/components/PageComponent";
import openFile from "../shared/functions/download";

function FehlerprotokollZeit(props) {
  const { t } = useTranslation();
// Standard Variablen
    const {client, accessToken} = props;
    const {showErrorMessage} = useMessage();
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
// Arbeitsvariablen
    const [vorlagen,setVorlagen]=useState([]);
    const [vorlage,setVorlage]=useState(0);
    const [manstart,setManstart]=useState(false);
    const [startdat,setStartdat]=useState("");
    const [enddat,setEnddat]=useState(new Date(new Date().getTime() + 1000*60*60*24*1).getFullYear().toString()+'-'+pad(new Date(new Date().getTime() + 1000*60*60*24*1).getMonth()+1,2)+'-'+pad(new Date(new Date().getTime() + 1000*60*60*24*1).getDate(),2));
    const [ausgabeFormat,setAusgabeFormat]=useState("pdf");
    // Functions
    
    useEffect(() => {
        setIsLoading(true);
        const payload={
            "mandant": client, // this.props.client,
            "program":(location.pathname==="/WEBZF2")?"WEBZF2":"WEBZFP",
            "start": (location.pathname==="/WEBZF2")?"":"MODUL",
            "statement": "UEBERSICHT",
            }
            const headers={
                "Authorization": "Bearer "+accessToken,
            }
            apiRequest('POST', 'daten', payload, headers, postUebersicht);
        // eslint-disable-next-line
    }, []);
    const postUebersicht = (response) => {
        console.log(response.data)
        setIsLoading(false);
        if (response.status === 200) {
            if (!response.data.vorlagen||response.data.vorlagen.length===0){
                showErrorMessage(t("Es sind keine Vorlagen definiert"));
                navigate(-1);
            } else {
                setVorlagen(response.data.vorlagen);
            }
        } else {
          if (response) {
            console.log(response)
            showErrorMessage(response.data.message);
          } else {
            showErrorMessage(t("Keine Internetverbindung"));
          }
          navigate(-1)
        }
    }
    function closeModal(){
        setShowModal(false)
    }
    function Auswertung(){
        if (!enddat){
            showErrorMessage("Bitte geben Sie ein gültiges Bis Datum ein.")
            return
        }
        setShowModal(true)
        const payload={
            "mandant": client, 
            "program":(location.pathname==="/WEBZF2")?"WEBZF2":"WEBZFP",
            "start": (location.pathname==="/WEBZF2")?"":"MODUL",
            "statement": "AUSWERTUNG",
            "sdat": startdat,
            "end": enddat,
            "vorlage": vorlagen[vorlage].key,
            "format": ausgabeFormat,
        }
        const headers={
            "Authorization": "Bearer "+accessToken,
            "Accept": "application/pdf"
        }
        axios.post(API_BASE_URL+'daten', payload, {headers: headers, responseType: 'blob'})
            .then((response) => {
              console.log(response);
              var fileName = ausgabeFormat === "xlsx" ? "FehlerprotokollZeiterfassung.xlsx" : "FehlerprotokollZeiterfassung.pdf";
              var contentFile = response.data;
              openFile(fileName, contentFile);
              closeModal();
            })
            .catch(function (error) {
            console.log(error)
              showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
              closeModal();
            })
    }
    if (isLoading) {
      return <LoadingComponent path={props.location}/>
    }
    return(
        <Page>
            <Layout fullWidth>
                <Grid container justifyContent="center" spacing={2}>
                    <Grid item xs={12} sm={10} md={8} lg={6}>
                        <Box p={2}>
                            <Grid container justifyContent="center" spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        id="vorlagen"
                                        label={t("Auswahl Vorlage")}
                                        select
                                        fullWidth
                                        value={vorlage}
                                        onChange={(e) => {setVorlage(e.target.value)}}
                                        variant="outlined"
                                    >
                                        {(vorlagen)&&vorlagen.map((item,index)=>(
                                            <MenuItem key={index} value={index}>{item.bez}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                            icon={<CheckBoxOutlineBlankIcon fontSize="small"/>}
                                            checkedIcon={<CheckBoxIcon fontSize="small"/>}
                                            value={manstart}
                                            onChange={(e)=>{setManstart(e.target.checked);(e.target.checked?setStartdat(enddat):setStartdat(""))}}
                                            />
                                            }
                                        label={"Startdatum manuell vorgeben"}
                                    />         
                                </Grid> 
                                <Grid item xs={12}>
                                    {
                                    manstart ?
                                    <DateTextField
                                    id="startdatum"
                                    label={t("Startdatum")}
                                    fullWidth
                                    disabled={!manstart}
                                    value={startdat}
                                    onChange={(e) => {setStartdat(e.target.value)}}
                                    variant="outlined"
                                />
                                :
                                <TextField
                                id="startdatum"
                                label={t("Startdatum")}
                                fullWidth
                                disabled={!manstart}
                                value={startdat}
                                onChange={(e) => {setStartdat(e.target.value)}}
                                variant="outlined"
                            />
                                    }
                                </Grid>
                                <Grid item xs={12}>
                                    <DateTextField
                                        id="enddatum"
                                        label={t("Enddatum")}
                                        fullWidth
                                        value={enddat}
                                        onChange={(e) => {setEnddat(e.target.value)}}
                                        variant="outlined"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        id="vorlagen"
                                        label={t("Ausgabeformat")}
                                        select
                                        fullWidth
                                        value={ausgabeFormat}
                                        onChange={(e) => {setAusgabeFormat(e.target.value)}}
                                        variant="outlined"
                                    >
                                        <MenuItem key="xlsx" value="xlsx">Excel Datei</MenuItem>
                                        <MenuItem key="pdf" value="pdf">PDF Datei</MenuItem>
                                    </TextField>
                                </Grid>
                                <Grid item xs={12}>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        color="primary"
                                        value={enddat}
                                        onClick={(e) => Auswertung()}
                                    >
                                        {t("Auswertung starten")}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
            </Layout>
            {showModal && <FullPageSpinner/>}
        </Page>
    )
}
export default FehlerprotokollZeit;
